import { render, staticRenderFns } from "./articleListComponent.vue?vue&type=template&id=cc1dd554&scoped=true"
import script from "./articleListComponent.vue?vue&type=script&lang=js"
export * from "./articleListComponent.vue?vue&type=script&lang=js"
import style0 from "./articleListComponent.vue?vue&type=style&index=0&id=cc1dd554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1dd554",
  null
  
)

export default component.exports